import { render, staticRenderFns } from "./08-search.vue?vue&type=template&id=3f5ee0be"
import script from "./08-search.vue?vue&type=script&lang=ts"
export * from "./08-search.vue?vue&type=script&lang=ts"
import style0 from "./08-search.vue?vue&type=style&index=0&id=3f5ee0be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports